export const MASKED_PHONE = 'XXX XXX XXXX';

// Customers without a name often have their number saved as the name, so any
// phone-shaped value is masked, not just phone fields.
export const looksLikePhone = (value: unknown): boolean => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!/^[+(\d][\d\s().+-]*$/.test(trimmed)) return false;
  return trimmed.replace(/\D/g, '').length >= 6;
};

// Deactivated accounts can't see their customers' phone numbers.
export const maskPhone = <T>(value: T, isActivated: boolean | undefined): T | string => {
  if (isActivated !== false || !looksLikePhone(value)) return value;
  return MASKED_PHONE;
};
